import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JS Modules
import DecapitalisedTitle from '../_utils/decapitalised-title';
import AppleDeviceNameCapitaliser from '../_utils/apple-device-name-capitaliser';
// Import JSX Modules
import FilterSelectorsMixin from './filter-selectors-mixin';

// -----------------------------------------------------------
//  FilterTextCriteron
// -----------------------------------------------------------

const FilterTextCriteron = createReactClass({
  mixins: [FilterSelectorsMixin],
  render() {
    return (
      <button
        className={classNames('btn selector text mw-100 text-truncate', { selected: this.props.selected, disabled: this.props.disabled })}
        ref="option"
        aria-disabled={this.props.disabled}
        aria-label={this.props.title}
        aria-pressed={this.props.selected}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleSelected}
      >
        <DecapitalisedTitle>
          <AppleDeviceNameCapitaliser>
            {this.props.title}
          </AppleDeviceNameCapitaliser>
        </DecapitalisedTitle>
        {this.disabledOverlay()}
      </button>
    );
  }
});

export default FilterTextCriteron;
